import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: '',
  template: ` <dx-toast
    [message]="message"
    [type]="type"
    [width]="width"
    [height]="height"
    [hideOnOutsideClick]="closeOnOutsideClick"
    [displayTime]="displayTime"
    maxWidth="30%"
    [position]="position"
    [animation]="animation"
    [visible]="true"
  >
  </dx-toast>`,
  styleUrls: ['./devExNotification.component.scss'],
  standalone: false,
})
export class DevExNotificationComponent implements OnInit {
  @Input() message: string;
  @Input() displayTime: number;
  @Input() type: string;
  @Input() width: string;
  @Input() closeOnOutsideClick: boolean;
  @Input() height: string | number;
  @Input() position: Object = { at: 'top center', my: 'top center', offset: '0 60' };
  @Input() animation: Object = {
    show: { type: 'slide', duration: 200, from: { position: { my: 'top', at: 'top', of: window } } },
    hide: { type: 'fade', duration: 400, to: 0 },
  };

  constructor() {}

  ngOnInit() {}
}
